const BASE_ACTION = "TAGS_LIST/";
export const FETCH_TAGS_START = `${BASE_ACTION}FETCH_TAGS_START`;
export const UPDATE_TAGS_VALUE = `${BASE_ACTION}UPDATE_TAGS_VALUE`;
export const RESET_TAGS_LIST = `${BASE_ACTION}RESET_TAGS_LIST`;
export const FETCH_TAGS_SUCCESS = `${BASE_ACTION}FETCH_TAGS_SUCCESS`;
// export const FETCH_TAGS_SUCCESS = `FETCH_TAGS_SUCCESS`;
export const FETCH_TAGS_FAIL = `${BASE_ACTION}FETCH_TAGS_FAIL`;
export const POST_TAG_START = `${BASE_ACTION}POST_TAG_START`;
export const POST_TAG_SUCCESS = `${BASE_ACTION}POST_TAG_SUCCESS`;
export const POST_TAG_FAIL = `${BASE_ACTION}POST_TAG_FAIL`;
export const FETCH_ALL_TAGS = `${BASE_ACTION}FETCH_ALL_TAGS`;
